export const isTaxNumber = (value: string): boolean => {
    const taxNumberRegex = /^[\d/]+$/;
    return taxNumberRegex.test(value);
};
